import { readFirstContactAccess } from './sm-first-contact-access.js';
const config = document.querySelector('[data-smfc-cart-gate]');
if (config) {
  const claim = config.dataset.claim;
  const id = '48645673910409';
  let checking = false;
  const go = () => window.location.assign(claim);
  const firstContactForm = form => String(new FormData(form).get('id')) === id;
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.action.includes('/cart/add') && firstContactForm(form)) {
      event.preventDefault(); event.stopImmediatePropagation(); go();
    }
  }, true);
  const verify = async () => {
    if (checking) return;
    checking = true;
    try {
      const response = await fetch(config.dataset.cart, {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('cart_unavailable');
      const cart = await response.json();
      if (cart.items.some(item => String(item.variant_id) === id)) {
        const access = await readFirstContactAccess(window.fetch.bind(window),new URL(config.dataset.access,location.origin).toString());
        if (!access.subscribed) {go();return;}
      }
      window.location.assign(config.dataset.checkout);
    } catch { go(); }
    finally {checking=false;}
  };
  document.addEventListener('click', event => {
    const target=event.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    if (!target || !document.querySelector('[data-smfc-in-cart]')) return;
    event.preventDefault();event.stopImmediatePropagation();verify();
  },true);
  document.addEventListener('submit',event=>{
    if (event.submitter?.name !== 'checkout' || !document.querySelector('[data-smfc-in-cart]')) return;
    event.preventDefault();event.stopImmediatePropagation();verify();
  },true);
}
